"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import {
  createReactives,
  queueReactiveToInstall,
  reactively
} from "@reactively/decorate";
import { LitElement, noChange } from "lit";
const _ReactiveLitElement = class extends LitElement {
  __reactive;
  _comboProps;
  static _buildingReactiveProperty = false;
  constructor() {
    super();
    createReactives(this);
    this.validateRender();
  }
  reactiveRender() {
    return noChange;
  }
  get template() {
    this.requestUpdate();
    return this.reactiveRender();
  }
  render() {
    return this.template;
  }
  validateRender() {
    const renderProto = hasRender(this);
    if (renderProto?.constructor?.name !== _ReactiveLitElement.name) {
      console.error(
        "ReactiveLitElement subclasses should not implement render(). \nImplement reactiveRender() instead.\n",
        "class:",
        this.constructor.name,
        "\n",
        "instance:",
        this
      );
    }
    function hasRender(self) {
      if (self === void 0) {
        return void 0;
      }
      if (Object.getOwnPropertyNames(self).includes("render")) {
        return self;
      }
      return hasRender(Object.getPrototypeOf(self));
    }
  }
  static getPropertyDescriptor(name, key, options) {
    const litDescriptor = super.getPropertyDescriptor(name, key, options);
    if (!this._buildingReactiveProperty) {
      return litDescriptor;
    } else {
      return {
        get: function() {
          return this.__reactive[name].get();
        },
        set: function(value) {
          const reactive = this.__reactive[name];
          const oldValue = reactive.get();
          reactive.set(value);
          this.requestUpdate(name, oldValue, options);
        },
        configurable: true,
        enumerable: true
      };
    }
  }
};
export let ReactiveLitElement = _ReactiveLitElement;
__decorateClass([
  reactively({ effect: true })
], ReactiveLitElement.prototype, "template", 1);
export function reactiveProperty(options) {
  return function reactiveComboProp(proto, key, descriptor) {
    queueReactiveToInstall(proto, key, descriptor, options);
    installComboAccessor(proto, key, descriptor, options);
    return {};
  };
}
function installComboAccessor(proto, key, descriptor, options) {
  if (descriptor?.get) {
    installGetAccessor(proto, key);
  }
  ReactiveLitElement._buildingReactiveProperty = true;
  proto.constructor.createProperty(key, options);
  ReactiveLitElement._buildingReactiveProperty = false;
}
function installGetAccessor(proto, key) {
  Object.defineProperty(proto, key, {
    get: function reactiveGet() {
      return this.__reactive[key].get();
    }
  });
}
